<template>
    <v-dialog  fullscreen scrollable v-model="dialog" transition="dialog-bottom-transition" >

        <v-card>
          <v-toolbar tabs fixed dark color="primary" class="absolute top pa-0 ">

            <v-btn icon @click="hide" class="mr-2">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            Ingresar {{getLabel('commons.client.singular')}}
            <v-spacer></v-spacer>
            <v-btn :loading="loading"  :disabled="!valid || !validClient" color="transparent" depressed @click="save">Guardar</v-btn>
          </v-toolbar>

          <v-card-text>
                <v-container mt-4>
                    <v-layout wrap align-center justify-center>
                        <v-flex xs12 md8 xl6  pt-4 mt-4>
                            <v-layout wrap>
                                <template v-if="appointment && appointment.client">
                                    <v-flex xs12  text-center>
                                        <v-card flat color="secondary-card">
                                            <v-toolbar dark flat :color="valid ? 'success' : 'error'" >
                                                <v-icon class="mr-2">fa-calendar-alt</v-icon>
                                                Cita
                                                <v-spacer></v-spacer>
                                                <v-icon class="mr-2">{{valid ? 'fa-check-circle' : 'fa-info-circle'}}</v-icon>
                                            </v-toolbar>
                                            <v-card-text>
                                                <appointment-reason-picker
                                                    :error-messages="reasonError"
                                                    v-on:change="onReasonSelect"
                                                    :value="reason" />
                                            </v-card-text>
                                        </v-card>
                                    </v-flex>
                                    <v-flex xs12  text-center pt-3>
                                        <v-card flat color="secondary-card">
                                            <v-toolbar dark flat :color="validPayment ? 'success' : 'error'" @click="showPaymentData = !showPaymentData">
                                                <v-icon class="mr-2">fas fa-money-bill-wave</v-icon>
                                                Datos de Pago
                                                <v-spacer></v-spacer>
                                                <v-icon class="mr-2">{{validPayment ? 'fa-check-circle' : 'fa-info-circle'}}</v-icon>
                                            </v-toolbar>
                                            <v-card-text v-show="showPaymentData">
                                                <attention-payment-form
                                                    ref="paymentForm"
                                                    :value="appointment.payment"
                                                    v-on:update:valid="validPayment = $event"
                                                />
                                            </v-card-text>
                                        </v-card>
                                    </v-flex>
                                    <v-slide-y-transition>
                                        <template v-show="appointment && appointment.client">
                                            <v-flex xs12  text-center pt-3>
                                                <v-card flat color="secondary-card">
                                                    <v-toolbar dark flat :color="validClient ? 'success' : 'error'" @click="showClientData = !showClientData">
                                                        <v-icon class="mr-2">fa-user</v-icon>
                                                        Datos del {{getLabel('commons.client.singular')}}
                                                        <v-spacer></v-spacer>
                                                        <v-icon class="mr-2">{{validClient ? 'fa-check-circle' : 'fa-info-circle'}}</v-icon>
                                                    </v-toolbar>
                                                    <v-card-text v-show="showClientData">
                                                        <patient-form
                                                            :required-fields="requiredFields"
                                                            ref="patientForm"
                                                            :value="appointment && appointment.client || null"
                                                            v-on:update:valid="validClient = $event"/>
                                                    </v-card-text>
                                                </v-card>
                                            </v-flex>
                                        </template>
                                    </v-slide-y-transition>
                                </template>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

    import AppointmentReasonPicker from '@/components/appointments/AppointmentReasonPicker'
    import PatientForm from '@/components/common/signup/PatientForm'
    import AttentionPaymentForm from '@/components/payment/AttentionPaymentForm'

    import {ApiUtils} from '@/utils/ApiUtils'
    import {getLabel} from '@/utils/Institution'

    import {mapState, mapMutations} from 'vuex'

    export default{
        components: {
            AppointmentReasonPicker,
            PatientForm,
            AttentionPaymentForm
        },
        props: [],
        data(vm){
            return {
                dialog: false,
                showClientData: true,
                showPaymentData: true,
                other: false,
                editClient: false,
                reason: vm.appointment &&
                            vm.appointment.client &&
                            vm.appointment.client.appointment_reason || null,
                appointment: null,
                loading: false,
                validClient: true,
                validPayment: false,
                rules: [
                    v => !!v || 'Este campo es obligatorio',
                    v => v.length > 10 || 'Requiere al menos 10 caracteres',
                ]
            }
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            getLabel,
            show(appointment){
                this.appointment = appointment
                this.payment = appointment.payment || null
                this.reason = null
                this.dialog = true
            },
            hide(){
                this.dialog = false
            },
            onReasonSelect(reason){
                this.reason = reason
            },
            async save(){
                var vm = this

                if(vm.loading) return

                vm.loading = true
                const userResponse = await vm.saveClient()
                if(!userResponse.ok){
                    vm.loading = false
                    const json = await userResponse.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando guardar los datos del ' + getLabel('commons.client.singular').toLowerCase())
                    return
                }

                const paymentResponse = await vm.savePayment()
                if(!paymentResponse.ok){
                    vm.loading = false
                    const json = await paymentResponse.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando guardar los datos de pago')
                    return
                }

                const response = await ApiUtils.makePost(`appointments/${vm.appointment.id}/arrive`, {
                    appointment_reason_id: vm.reason.id
                })
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando ingredar al ' + getLabel('commons.client.singular').toLowerCase())
                    vm.$emit('error', json)
                    return
                }

                const json = await response.json()
                vm.showSnackBar(`${getLabel('commons.client.singular')} ingresado correctamente`)
                vm.$emit('success', json)
                vm.hide()

            },
            async saveClient(){
                var vm = this
                if(!vm.currentProvider || !vm.appointment.client) return
                return await ApiUtils.makePatch(
                        `providers/${vm.currentProvider.id}/client/${vm.appointment.client.id}`,
                        null,
                        vm.$refs.patientForm.getUserData()
                )
            },
            async savePayment(){
                var vm = this
                return await ApiUtils.makePost(
                        `payment/${vm.appointment.id}`,
                        vm.$refs.paymentForm.getPaymentData()
                )
            }
        },
        computed: {
                ...mapState(['currentProvider']),
            requiredFields(){
                return [
                    'dni',
                    'firstName',
                    'lastName',
                    'phone1',
                    'insuranceCompany',
                    'birthDate',
                ]
            },
            reasonError(){
                var vm = this
                if(!vm.reason){
                    return 'El motivo de la cita es obligatorio'
                }

                return ''

            },
            valid(){
                var vm = this
                return ((vm.reason && vm.reason !== 'other') || (vm.customReason && vm.reason === 'other'))
            },
            baseReasons(){
                return [
                    {
                        text: `El ${getLabel('commons.client.singular').toLowerCase()} encontro hora en otro centro`,
                        value: 'another_institution'
                    },
                    {
                        text: `No se pudo contactar al ${getLabel('commons.client.singular').toLowerCase()}`,
                        value: 'cant_contact_client'
                    },
                    {
                        text: `Otro`,
                        value: 'other'
                    },
                ]
            }
        },
        watch:{
            reason(val){}
        }

    }
</script>
